import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { City } from './city'

export class CitiesRepository extends BaseRepository<City> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.prospectApiUrl + '/' + 'cities', token, cache)
    }
}
